import type { FeatureActionLinkEnum } from '@/constants'
import { ActionLinkStart } from '@/constants'

export const getActionDataFromText = (text: string) => {
  const actionData = {
    ...(new RegExp(
      `^{?${ActionLinkStart}:(?<action>.*?)(:(?<param>.*?))?}?$`,
    ).exec(text)?.groups as {
      action: FeatureActionLinkEnum
      param?: string
    }),
  }
  return {
    actionData,
    link: undefined,
  } as const
}
